import React, { useContext } from 'react';

import WomenImg from '../img/about/kamesh12.png';

import { Link } from 'react-router-dom';
import { motion } from 'framer-motion';
import { transition1 } from '../transitions';

import { CursorContext } from '../context/CursorContext';

const About = () => {
  const { mouseEnterHandler, mouseLeaveHandler } = useContext(CursorContext);
  return (
    <motion.section
      initial={{ opacity: 0, y: window.innerWidth }}
      animate={{ opacity: 1, y: 0 }}
      exit={{ opacity: 0, x: window.innerWidth }}
      transition={transition1}
      className="section hero"
    >
      <div className="container mx-auto h-full relative">
        <div className="flex flex-col lg:flex-row h-full items-center justify-center  gap-x-18 text-center lg:text-left lg:pt-16">
          <div className="flex-1 w-40 lg:max-h-max order-1 lg:order-none overflow-hidden">
            <motion.img
              whileHover={{ scale: 1.1 }}
              transition={transition1}
              src={WomenImg}
              alt=""
            />
          </div>
          <div
            onMouseEnter={mouseEnterHandler}
            onMouseLeave={mouseLeaveHandler}
            className="flex-1 pt-32 pb-0 lg:pt-0 lg:w-auto z-8 flex flex-col justify-center items-center px-10 text-center lg:items-start text-primary "
          >
            <h1 className="h1 py-3">About Me</h1>

            <p className="text-lg lg:text-xl  text-justify ">
              Hello, my name is Kameshwaran E, and I'm a 23-year-old Indian
              residing in Tamil Nadu. I Graduated my MCA and a BSc from Vellore
              Institute of Technology, and I strive hard to improve my knowledge
              and abilities while delivering high-quality work.
            </p>
            <Link to={'/skills'} className="btn my-3.5">
              View my Skills
            </Link>
          </div>
        </div>
      </div>
    </motion.section>
  );
};

export default About;
